// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'react-toastify/dist/ReactToastify.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { HelmetProvider } from 'react-helmet-async';
import { ToastContainer } from 'react-toastify';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
      <ToastContainer
        position="bottom-left"
        autoClose={false}
        hideProgressBar={false}
        closeOnClick
        rtl
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{ fontFamily: 'Vazirmatn, Tahoma, sans-serif' }}
      />
    </HelmetProvider>
  </React.StrictMode>
);

// فقط در مرورگر واقعی (نه react-snap)
if (
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  !navigator.userAgent.includes('ReactSnap')
) {
  serviceWorkerRegistration.register();
}

if (process.env.NODE_ENV === 'development') {
  reportWebVitals(console.log);
}